import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { CompanyContractModule } from '../companyContract/companyContract.module';
import { UserClientComponent } from './userClient.component';
import { UserClientListComponent } from './userClient-list.component';
import { UserClientReadComponent } from './userClient-read.component';
import { UserClientCreateComponent } from './userClient-create.component';
import { UserClientUpdateComponent } from './userClient-update.component';
import { UserClientUpdatePasswordComponent } from './userClient-update-password.component';
import { UserClientService } from './userClient.service';
import { UserService } from '../user/user.service';
import { AuthRoleService } from '../auth/authRole.service';
import { dashboardRouting } from '../dashboard/dashboard.routes';
import { ContextMenuModule } from 'ngx-contextmenu';
import { MatTableModule, MatCheckboxModule, MatPaginatorModule, MatSortModule, MatExpansionModule, MatSelectModule } from '@angular/material';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		SharedModule,
		dashboardRouting,
		CompanyContractModule,
		ReactiveFormsModule,
		ContextMenuModule,
		MatTableModule,
		MatCheckboxModule,
		MatPaginatorModule,
		MatSortModule,
		MatExpansionModule,
		MatSelectModule
	],
	declarations: [
		UserClientComponent,
		UserClientListComponent,
		UserClientReadComponent,
		UserClientCreateComponent,
		UserClientUpdateComponent,
		UserClientUpdatePasswordComponent
	],
	providers: [
		UserClientService,
		UserService,
		AuthRoleService
	],
})
export class UserClientModule { }
